import { render, staticRenderFns } from "./CoreFullscreen.vue?vue&type=template&id=181a6913&scoped=true"
import script from "./CoreFullscreen.vue?vue&type=script&lang=js"
export * from "./CoreFullscreen.vue?vue&type=script&lang=js"
import style0 from "./CoreFullscreen.vue?vue&type=style&index=0&id=181a6913&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181a6913",
  null
  
)

export default component.exports